<template xmlns:v-swiper="http://www.w3.org/1999/xhtml">
  <div class="index-fullwidth mt15">
    <div class="affiliate_offer"></div>
    <!--<code>{{category_products}}</code>-->
    <div class="banner-area col-md-12  story-banner">
      <div v-swiper:mySwiper="swiperOption">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(story, index) in stories"
            :key="story.id"
          >
            <div>
              <img
                @click="StoreShow(story.image, story.url)"
                data-toggle="modal"
                data-target="#storyModal"
                v-bind:src="fileUrl + 'uploads/story_images/' + story.image"
                :alt="story.title"
                class="img-responsive img-rounded minimum-border"
              />
              <!-- <div class="offer">{{ story.title }}</div> -->
            </div>
          </div>
        </div>

        <!-- Navigation buttons - must be here -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <div
      id="storyModal"
      tabindex="-1"
      role="dialog"
      class="modal fade quickModal"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-auto-width"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-body p-0">
            <button type="button" data-dismiss="modal" class="close closebtn">
              ×
            </button>

            <a :href="storyUrl">
              <img
                v-if="storyImage"
                :src="fileUrl + 'uploads/story_images/' + storyImage"
                class="img-fluid img-rounded"
                :alt="globalLanguage == 'EN' ? 'Story Image' : 'স্টোরি ছবি'"
              />
            </a>
          </div>
        </div>
      </div>
    </div>

    <section class="home-grocery-promo">
      <div class="home-grocery-copy">
        <h1 v-if="globalLanguage == 'EN'">YOUR FAVORITE FOODS, DELIVERED TO YOUR DOOR</h1>
        <h1 v-else>আপনার পছন্দের খাবার, এখন আপনার দোরগোড়ায়</h1>
        <div class="home-grocery-cuisines" v-if="globalLanguage == 'EN'">
          <span>Asian</span>
          <span>African</span>
          <span>Bangladeshi</span>
          <span>Indian</span>
          <span>Pakistanais</span>
          <span>French</span>
        </div>
        <div class="home-grocery-cuisines bn" v-else>
          <span>এশিয়ান</span>
          <span>আফ্রিকান</span>
          <span>বাংলাদেশি</span>
          <span>ভারতীয়</span>
          <span>পাকিস্তানি</span>
          <span>ফরাসি</span>
        </div>
        <form class="home-grocery-search" v-on:submit.prevent="focusHeaderSearch">
          <input
            type="text"
            v-model="promoSearch"
            @focus="focusHeaderSearch"
            @input="syncPromoSearch"
            :placeholder="
              globalLanguage == 'EN'
                ? 'Search for products (e.g. eggs, milk, potato)'
                : 'পণ্য খুঁজুন (যেমন: চাল, ডাল, তেল)'
            "
          />
          <button
            type="submit"
            :aria-label="globalLanguage == 'EN' ? 'Search products' : 'পণ্য খুঁজুন'"
          >
            <i class="fa fa-search"></i>
          </button>
        </form>
      </div>
      <div class="home-grocery-media" aria-hidden="true">
        <div class="home-grocery-photo photo-main">
          <img src="@/assets/images/test/5.png" alt="" />
        </div>
        <div class="home-grocery-photo photo-top">
          <img src="@/assets/images/test/6.jpg" alt="" />
        </div>
        <div class="home-grocery-photo photo-mid">
          <img src="@/assets/images/test/5.png" alt="" />
        </div>
        <div class="home-grocery-photo photo-tall">
          <img src="@/assets/images/test/6.jpg" alt="" />
        </div>
        <div class="home-grocery-photo photo-bottom">
          <img src="@/assets/images/test/5.png" alt="" />
        </div>
        <div class="home-grocery-photo photo-edge">
          <img src="@/assets/images/test/6.jpg" alt="" />
        </div>
      </div>
    </section>

    <div class="container-fluid sha-home-section sha-benefits-section" id="banner_bottom">
      <div class="row sha-benefits-row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 sha-benefit-col">
          <div class="sha-benefit-card">
            <img src="@/assets/images/icons/shop-orange.png" alt="" />
            <p v-if="globalLanguage == 'EN'">
              <b>+15000 products</b>
              <span>to shop from</span>
            </p>
            <p v-else>
              <b>+১৫০০০ পণ্য</b>
              <span>কেনাকাটার জন্য</span>
            </p>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 sha-benefit-col">
          <div class="sha-benefit-card">
            <img src="@/assets/images/icons/purse.png" alt="" />
            <p v-if="globalLanguage == 'EN'">
              <span>Pay <b>after</b> receiving</span>
              <span>products</span>
            </p>
            <p v-else>
              <span>পণ্য পাওয়ার <b>পরে</b></span>
              <span>পেমেন্ট করুন</span>
            </p>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 sha-benefit-col">
          <div class="sha-benefit-card">
            <img src="@/assets/images/icons/fast-delivery.png" alt="" />
            <p v-if="globalLanguage == 'EN'">
              <span>Get your delivery</span>
              <span>within <b>1 hour</b></span>
            </p>
            <p v-else>
              <span>ডেলিভারি পান</span>
              <span><b>১ ঘণ্টার</b> মধ্যে</span>
            </p>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 sha-benefit-col">
          <div class="sha-benefit-card">
            <img src="@/assets/images/icons/payment-method.png" alt="" />
            <p v-if="globalLanguage == 'EN'">
              <span>Get offers that</span>
              <b>Save Money</b>
            </p>
            <p v-else>
              <span>অফার পান</span>
              <b>সাশ্রয় করুন</b>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid sha-home-section sha-categories-section">
      <div class="sha-section-container">
        <div class="row categories category-block">
          <div class="col-lg-12 sec-title sha-section-heading">
            <div class="sha-title-inline" v-if="globalLanguage == 'EN'">
              <h4>Shop By Category</h4>
            </div>
            <div class="sha-title-inline" v-else>
              <h4>ক্যাটাগরি অনুযায়ী কেনাকাটা</h4>
            </div>
            <div class="sha-slider-arrows">
              <button
                type="button"
                class="sha-slider-arrow"
                :aria-label="
                  globalLanguage == 'EN'
                    ? 'Previous categories'
                    : 'আগের ক্যাটাগরি'
                "
                @click="slideFeaturedCategories('prev')"
              >
                <i class="fa fa-angle-left"></i>
              </button>
              <button
                type="button"
                class="sha-slider-arrow"
                :aria-label="
                  globalLanguage == 'EN' ? 'Next categories' : 'পরের ক্যাটাগরি'
                "
                @click="slideFeaturedCategories('next')"
              >
                <i class="fa fa-angle-right"></i>
              </button>
            </div>
          </div>
          <div class="clearfix"></div>
          <div class="sha-category-swiper" v-swiper:featuredCategorySwiper="categorySwiperOptions">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="mainCategory in featuredCategorylist"
                :key="mainCategory.slug"
              >
                <div class="bindarea">
                  <router-link
                    :to="{ path: '/' + mainCategory.slug }"
                    class="cat"
                  >
                    <div>
                      <img
                        v-if="mainCategory.cat_img"
                        v-bind:src="
                          fileUrl + 'uploads/cat_images/' + mainCategory.cat_img
                        "
                        :alt="
                          globalLanguage == 'EN'
                            ? mainCategory.cat_name
                            : mainCategory.sub_cat_name_bn
                        "
                      />
                      <img
                        v-else
                        src="@/assets/images/default.png"
                        :alt="
                          globalLanguage == 'EN'
                            ? mainCategory.cat_name
                            : mainCategory.sub_cat_name_bn
                        "
                      />
                    </div>
                    <div class="cname" v-if="globalLanguage == 'EN'">
                      {{
                        mainCategory.sub_cat_name.length > 30
                          ? mainCategory.sub_cat_name.substring(0, 30) + "..."
                          : mainCategory.sub_cat_name
                      }}
                    </div>
                    <div class="cname" v-else>
                      {{
                        mainCategory.sub_cat_name_bn.length > 30
                          ? mainCategory.sub_cat_name_bn.substring(0, 30) + "..."
                          : mainCategory.sub_cat_name_bn
                      }}
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="banner-area products-banner sha-home-section sha-offers-section"
      v-if="offer_products && offer_products.length > 0"
    >
      <div>
        <div>
      <div class="col-lg-12 sec-title mb20 sha-section-heading sha-products-heading">
        <div class="sha-title-inline" v-if="globalLanguage == 'EN'">
          <h4>Offers</h4>
        </div>
        <div class="sha-title-inline" v-else>
          <h4>অফার</h4>
        </div>
        <div class="sha-slider-arrows" v-if="offer_products.length > 5">
          <button
            type="button"
            class="sha-slider-arrow"
            :aria-label="
              globalLanguage == 'EN' ? 'Previous offers' : 'আগের অফার'
            "
            @click="slideOfferProducts('prev')"
          >
            <i class="fa fa-angle-left"></i>
          </button>
          <button
            type="button"
            class="sha-slider-arrow"
            :aria-label="
              globalLanguage == 'EN' ? 'Next offers' : 'পরের অফার'
            "
            @click="slideOfferProducts('next')"
          >
            <i class="fa fa-angle-right"></i>
          </button>
        </div>
      </div>
      <div class="clearfix"></div>
      <div id="offerProductsSwiper" v-swiper:mySwiperOffers="swiperOptionsPopular">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide featured"
            v-for="product in offer_products"
            :key="'offer-' + product.id"
          >
            <div class="each">
              <div class="area-img">
                <div
                  class="wishlist-toggle"
                  :class="{ active: inWishlist(product.id) }"
                  @click="toggleWishlistClick(product)"
                >
                  <i
                    class="fa"
                    :class="inWishlist(product.id) ? 'fa-heart' : 'fa-heart-o'"
                  ></i>
                </div>
                <img
                  v-bind:src="
                    fileUrl + 'uploads/products/' + product.featured_image
                  "
                  :alt="globalLanguage == 'EN' ? product.name : product.name_bn"
                  class="img-responsive"
                  style="cursor:pointer;"
                  @click="addRelatedToCart(product)"
                />
              </div>
              <div class="summary">
                <div class="price">
                  <span class="running"
                    >{{ (product.price - product.discount).toFixed(2) }} &#8364;
                  </span>
                  <span class="discounted" v-if="product.discount > 0">
                    {{ product.price }} &#8364;</span
                  >
                </div>
                <h3
                  class="name"
                  style="cursor:pointer;"
                  data-toggle="modal"
                  data-target="#quickModal"
                  @click="homeQuickView(product.id)"
                  v-if="globalLanguage == 'EN'"
                >
                  {{ product.name }} {{ product.strength }}
                </h3>
                <h3
                  class="name bn"
                  style="cursor:pointer;"
                  data-toggle="modal"
                  data-target="#quickModal"
                  @click="homeQuickView(product.id)"
                  v-else
                >
                  {{ product.name_bn }} {{ product.strength }}
                </h3>
                <div class="weight">
                  {{ product.unit_quantity }} {{ product.unit }}
                </div>
                <div class="price">
                  <ProductCartControl
                    v-if="product.stock_quantity > 0"
                    control-class="home-cart-control category-cart-control"
                    :no-swiping="true"
                    :product-id="product.id"
                    :language="globalLanguage"
                    :quantity="getCartQuantity(product.id)"
                    :in-cart="hasCartQuantity(product.id)"
                    @add="addRelatedToCart(product)"
                    @decrement="cartDecrement(product.id)"
                    @increment="cartIncrement(product.id)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        </div>
      </div>
    </div>

    <div class="banner-area products-banner sha-home-section sha-popular-products-section">
      <div>
        <div>
      <div class="col-lg-12 sec-title mb20 sha-section-heading sha-products-heading">
        <div class="sha-title-inline" v-if="globalLanguage == 'EN'">
          <h4>Fresh Products</h4>
        </div>
        <div class="sha-title-inline" v-else>
          <h4>তাজা পণ্য</h4>
        </div>
        <div class="sha-slider-arrows" v-if="products.length > 5">
          <button
            type="button"
            class="sha-slider-arrow"
            :aria-label="
              globalLanguage == 'EN' ? 'Previous products' : 'আগের পণ্য'
            "
            @click="slidePopularProducts('prev')"
          >
            <i class="fa fa-angle-left"></i>
          </button>
          <button
            type="button"
            class="sha-slider-arrow"
            :aria-label="
              globalLanguage == 'EN' ? 'Next products' : 'পরের পণ্য'
            "
            @click="slidePopularProducts('next')"
          >
            <i class="fa fa-angle-right"></i>
          </button>
        </div>
      </div>
      <div class="clearfix"></div>
      <div id="quickModal" tabindex="-1" role="dialog" class="modal quickModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" data-dismiss="modal" class="close">
                ×
              </button>
              <div class="row">
                <div class="col-md-5">
                  <div class="breadcum mb15" v-if="modalData">
                    <i aria-hidden="true" class="fa fa-circle-o"></i>
                    <span v-if="globalLanguage == 'EN'">
                      {{ modalData.name }}
                    </span>
                    <span v-else>
                      {{ modalData.name_bn }}
                    </span>
                  </div>
                  <div class="right-border img-max-height" v-if="modalData">
                    <img
                      v-if="
                        changeModalGallery_image === modalData.featured_image
                      "
                      v-bind:src="
                        fileUrl + 'uploads/products/' + modalData.featured_image
                      "
                      class="img-responsive"
                    />
                    <img
                      v-else
                      v-bind:src="
                        fileUrl + 'uploads/products/' + changeModalGallery_image
                      "
                      class="img-responsive"
                    />
                  </div>
                </div>
                <div class="col-md-7" v-if="modalData">
                  <h3 class="m-p-title" v-if="globalLanguage == 'EN'">
                    {{ modalData.name }}
                  </h3>
                  <h3 class="m-p-title" v-else>{{ modalData.name_bn }}</h3>
                  <div class="code">
                    <span v-if="globalLanguage == 'EN'">Code:</span>
                    <span v-else>কোড:</span>
                    <b>#{{ modalData.id }}</b>
                  </div>
                  <div class="code">
                    <span v-if="globalLanguage == 'EN'">Quantity:</span>
                    <span v-else>পরিমাণ:</span>
                    <b>{{ modalData.unit_quantity }}{{ modalData.unit }}</b>
                  </div>

                  <div class="code">
                    <span v-if="globalLanguage == 'EN'">Availability:</span>
                    <span v-else>স্টক:</span>
                    <span
                      class="green-color text-uppercase"
                      style="font-size: 12px"
                      v-if="modalData.stock_quantity > 0"
                      >
                      <span v-if="globalLanguage == 'EN'">In Stock</span>
                      <span v-else>স্টকে আছে</span>
                    </span
                    >
                    <span class="stock-out" style="font-size: 12px" v-else
                      >
                      <span v-if="globalLanguage == 'EN'">Out of Stock</span>
                      <span v-else>স্টকে নেই</span>
                    </span
                    >
                  </div>

                  <div class="code mt10" v-if="modalData.dosages_description">
                    Type:
                    {{ modalData.dosages_description }}
                  </div>
                  <div class="code" v-if="modalData.strength">
                    Strength: {{ modalData.strength }}
                  </div>
                  <div class="code" v-if="modalData.generic_name">
                    Generic Name: {{ modalData.generic_name }}
                  </div>

                  <div class="price mt5">
                    <h3 class="running base-color">
                      {{ (modalData.price - modalData.discount).toFixed(2) }}
                      &#8364;
                    </h3>
                    <span class="discounted" v-if="modalData.discount > 0"
                      ><span>
                        {{ modalData.price.toFixed(2) }} &#8364;</span
                      ></span
                    >
                  </div>
                  <div class="quick-modal-actions">
                    <div class="quick-modal-stepper">
                      <div class="quantity mt15 clearfix">
                      <div v-if="globalLanguage == 'EN'">Quantity</div>
                      <div v-else>পরিমাণ</div>
                        <div class="pull-left">
                          <span variant="info" @click="decrement(modalData.id)"
                            ><img
                              src="@/assets/images/minus-yellow.png"
                              width="24px"
                          /></span>
                        </div>
                        <input
                          class="pull-left text-center"
                          type="text"
                          min="1"
                          :value="quantity"
                          readonly
                        />
                        <div class="pull-left">
                          <span variant="info" @click="increment(modalData.id)"
                            ><img src="@/assets/images/plusorange.png" width="24px"
                          /></span>
                        </div>
                      </div>
                    </div>
                    <div class="quick-modal-cart-action">
                      <button
                        type="button"
                        class="btn btn-add-to-cart btn-sm mt30"
                        v-if="
                          modalData.stock_quantity > 0 && globalLanguage == 'EN'
                        "
                        @click="createCartsModal()"
                      >
                        Add to Bag
                      </button>
                      <button
                        type="button"
                        class="btn btn-add-to-cart bn btn-sm mt30"
                        v-if="
                          modalData.stock_quantity > 0 && globalLanguage != 'EN'
                        "
                        @click="createCartsModal()"
                      >
                        ব্যাগে যোগ করুন
                      </button>
                    </div>
                  </div>

                </div>
                <div class="col-md-12 pd0" v-if="modalData">
                  <div v-if="modalData.gp_image_1">
                    <hr />
                    <div class="ml15 pull-left">
                      <div
                        class="gallery-img"
                        v-if="modalData.gp_image_1"
                        @click="galleryImg(modalData.gp_image_1)"
                      >
                        <img
                          v-bind:src="
                            fileUrl + 'uploads/products/' + modalData.gp_image_1
                          "
                          class="img-responsive"
                        />
                      </div>
                      <div
                        class="gallery-img"
                        v-if="modalData.gp_image_2"
                        @click="galleryImg(modalData.gp_image_2)"
                      >
                        <img
                          v-bind:src="
                            fileUrl + 'uploads/products/' + modalData.gp_image_2
                          "
                          class="img-responsive"
                        />
                      </div>
                      <div
                        class="gallery-img"
                        v-if="modalData.gp_image_3"
                        @click="galleryImg(modalData.gp_image_3)"
                      >
                        <img
                          v-bind:src="
                            fileUrl + 'uploads/products/' + modalData.gp_image_3
                          "
                          class="img-responsive"
                        />
                      </div>
                      <div
                        class="gallery-img"
                        v-if="modalData.gp_image_4"
                        @click="galleryImg(modalData.gp_image_4)"
                      >
                        <img
                          v-bind:src="
                            fileUrl + 'uploads/products/' + modalData.gp_image_4
                          "
                          class="img-responsive"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <ul
                    class="nav nav-tabs m-tab-menu mt0"
                    v-if="modalData.description"
                  >
                    <!--                  <li ><a data-toggle="tab" href="#Description">Reviews</a></li>-->
                    <li class="active">
                      <a data-toggle="tab" href="#Reviews">
                        <span v-if="globalLanguage == 'EN'">Description</span>
                        <span v-else>বিস্তারিত</span>
                      </a>
                    </li>
                  </ul>
                  <div class="tab-content ml15">
                    <div id="Description" class="tab-pane"></div>
                    <div
                      id="Reviews"
                      class="tab-pane fade in active"
                      style="padding-right: 15px"
                    >
                      <br />
                      <div v-html="modalData.description"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="related-products-section"
                v-if="related_products && related_products.length > 0"
              >
                <hr />
                <h4 class="related-title" v-if="globalLanguage == 'EN'">
                  You May Also Like
                </h4>
                <h4 class="related-title" v-else>আপনার পছন্দ হতে পারে</h4>
                <div class="related-products-scroll">
                  <div
                    class="related-product-card"
                    v-for="rp in related_products"
                    :key="rp.id"
                  >
                    <div
                      class="related-product-img"
                      style="cursor:pointer;"
                      @click="addRelatedToCart(rp)"
                    >
                      <img
                        v-bind:src="
                          fileUrl + 'uploads/products/' + rp.featured_image
                        "
                        :alt="globalLanguage == 'EN' ? rp.name : rp.name_bn"
                        class="img-responsive"
                      />
                      <ProductCartControl
                        control-class="related-cart-control"
                        :product-id="rp.id"
                        :language="globalLanguage"
                        :quantity="getCartQuantity(rp.id)"
                        :in-cart="hasCartQuantity(rp.id)"
                        @add="addRelatedToCart(rp)"
                        @decrement="cartDecrement(rp.id)"
                        @increment="cartIncrement(rp.id)"
                        @mouseleave="closeRelatedCartControl(rp.id)"
                      />
                    </div>
                    <div
                      class="related-product-info"
                      style="cursor:pointer;"
                      @click="homeQuickView(rp.id)"
                    >
                      <div class="related-product-price">
                        {{ (rp.price - rp.discount).toFixed(2) }} &#8364;
                      </div>
                      <div
                        class="related-product-name"
                        v-if="globalLanguage == 'EN'"
                      >
                        {{
                          rp.name.length > 18
                            ? rp.name.substring(0, 18) + "..."
                            : rp.name
                        }}
                      </div>
                      <div class="related-product-name" v-else>
                        {{
                          rp.name_bn.length > 18
                            ? rp.name_bn.substring(0, 18) + "..."
                            : rp.name_bn
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="popularProductsSwiper" v-swiper:mySwiperPopular="swiperOptionsPopular">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide featured"
            v-for="(product, index) in products"
            :key="product.id"
          >
            <div class="each">
              <div class="area-img">
                <div
                  class="wishlist-toggle"
                  :class="{ active: inWishlist(product.id) }"
                  @click="toggleWishlistClick(product)"
                >
                  <i
                    class="fa"
                    :class="inWishlist(product.id) ? 'fa-heart' : 'fa-heart-o'"
                  ></i>
                </div>
                <img
                  v-bind:src="
                    fileUrl + 'uploads/products/' + product.featured_image
                  "
                  :alt="globalLanguage == 'EN' ? product.name : product.name_bn"
                  class="img-responsive"
                  style="cursor:pointer;"
                  @click="addOrIncrementCart(index, product.id)"
                />
              </div>
              <div class="summary">
                <div class="price">
                  <span class="running"
                    >{{ (product.price - product.discount).toFixed(2) }} &#8364;
                  </span>
                  <span class="discounted" v-if="product.discount > 0">
                    {{ product.price }} &#8364;</span
                  >
                </div>
                <h3
                  class="name"
                  style="cursor:pointer;"
                  data-toggle="modal"
                  data-target="#quickModal"
                  @click="homeQuickView(product.id)"
                  v-if="globalLanguage == 'EN'"
                >
                  {{ product.name }} {{ product.strength }}
                </h3>
                <h3
                  class="name bn"
                  style="cursor:pointer;"
                  data-toggle="modal"
                  data-target="#quickModal"
                  @click="homeQuickView(product.id)"
                  v-else
                >
                  {{ product.name_bn }} {{ product.strength }}
                </h3>
                <div class="weight">
                  {{ product.unit_quantity }} {{ product.unit }}
                </div>
                <div class="price">
                  <ProductCartControl
                    v-if="product.stock_quantity > 0"
                    control-class="home-cart-control category-cart-control"
                    :no-swiping="true"
                    :product-id="product.id"
                    :language="globalLanguage"
                    :quantity="getCartQuantity(product.id)"
                    :in-cart="hasCartQuantity(product.id)"
                    @add="createCarts(index, product.id)"
                    @decrement="cartDecrement(product.id)"
                    @increment="cartIncrement(product.id)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        </div>
      </div>
    </div>
 <div
      class="banner-area products-banner caregoty-products sha-home-section sha-category-products-section"
      v-for="category in category_products"
      :key="category.slug"
      v-if="token && category.data && category.data.length > 0"
    >
      <div>
        <div>
      <div class="col-lg-12 sec-title mb20 sha-section-heading">
        <div class="sha-title-inline" v-if="globalLanguage == 'EN'">
          <h4>{{ category.name }}</h4>
        </div>
        <div class="sha-title-inline" v-else>
          <h4>{{ category.name_bn }}</h4>
        </div>
        <div class="sha-slider-arrows">
          <button
            type="button"
            class="sha-slider-arrow"
            :aria-label="
              globalLanguage == 'EN'
                ? 'Previous category products'
                : 'আগের ক্যাটাগরির পণ্য'
            "
            @click="slideCategoryProducts(category.slug, 'prev')"
          >
            <i class="fa fa-angle-left"></i>
          </button>
          <button
            type="button"
            class="sha-slider-arrow"
            :aria-label="
              globalLanguage == 'EN'
                ? 'Next category products'
                : 'পরের ক্যাটাগরির পণ্য'
            "
            @click="slideCategoryProducts(category.slug, 'next')"
          >
            <i class="fa fa-angle-right"></i>
          </button>
        </div>
      </div>
      <div class="clearfix"></div>
      <div :id="'categorySwiper-' + category.slug" v-swiper="swiperOptions">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide featured"
            v-for="(product, index) in category.data"
            :key="product.id"
          >
            <div class="each">
              <div class="area-img">
                <div
                  class="wishlist-toggle"
                  :class="{ active: inWishlist(product.id) }"
                  @click="toggleWishlistClick(product)"
                >
                  <i
                    class="fa"
                    :class="inWishlist(product.id) ? 'fa-heart' : 'fa-heart-o'"
                  ></i>
                </div>
                <img
                  v-bind:src="
                    fileUrl + 'uploads/products/' + product.featured_image
                  "
                  :alt="globalLanguage == 'EN' ? product.name : product.name_bn"
                  class="img-responsive"
                  style="cursor:pointer;"
                  @click="addRelatedToCart(product)"
                />
              </div>
              <div class="summary">
                <div class="price">
                  <span class="running"
                    >{{ (product.price - product.discount).toFixed(2) }} &#8364;
                  </span>
                  <span class="discounted" v-if="product.discount > 0">
                    {{ product.price }} &#8364;</span
                  >
                </div>
                <h3
                  class="name"
                  style="cursor:pointer;"
                  data-toggle="modal"
                  data-target="#quickModal"
                  @click="homeQuickView(product.id)"
                  v-if="globalLanguage == 'EN'"
                >
                  {{ product.name }} {{ product.strength }}
                </h3>
                <h3
                  class="name bn"
                  style="cursor:pointer;"
                  data-toggle="modal"
                  data-target="#quickModal"
                  @click="homeQuickView(product.id)"
                  v-else
                >
                  {{ product.name_bn }} {{ product.strength }}
                </h3>
                <div class="weight">
                  {{ product.unit_quantity }} {{ product.unit }}
                </div>
                <div class="price">
                  <ProductCartControl
                    v-if="product.stock_quantity > 0"
                    control-class="home-cart-control category-cart-control"
                    :no-swiping="true"
                    :product-id="product.id"
                    :language="globalLanguage"
                    :quantity="getCartQuantity(product.id)"
                    :in-cart="hasCartQuantity(product.id)"
                    @add="addRelatedToCart(product)"
                    @decrement="cartDecrement(product.id)"
                    @increment="cartIncrement(product.id)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination-feature"></div>
      </div>
        </div>
      </div>
    </div>

    <div class="medicine-area">
      <div class="container-fluid" style="padding: 0 5px !important;">
        <div class="col-md-12 mt15 upload">
          <div class="file-secd">
            <div class="box">
              <div class="row upload-bazar-row">

                <div
                  class="col-lg-6 col-md-6 col-sm-6"
                  style="padding: 0px; text-align: center;vertical-align: middle;"
                >
                  <img src="@/assets/images/test/5.png" class="upload-bazar-image" />
                </div>
                 <div class="col-lg-6 col-md-6 col-sm-6 text-center upload-bazar-copy">
                  <div v-if="language == 'EN'">
                    <h4>Upload Bazar List</h4>
                    <h3>GET HOME DELIVERY</h3>
                    <p>Send your shopping list and we will prepare your order.</p>
                    <button
                      data-toggle="modal"
                      data-target="#prescriptionModal"
                      data-dismiss="modal"
                      class="btn btn-base upload-bazar-button"
                    >
                      <i class="fa fa-upload"></i>
                      UPLOAD FILE
                    </button>
                  </div>
                  <div v-else>
                    <h4>বাজারের তালিকা আপলোড করুন</h4>
                    <h3>হোম ডেলিভারি সেবা নিন</h3>
                    <p>আপনার বাজারের তালিকা পাঠান, আমরা অর্ডার প্রস্তুত করব।</p>
                    <button
                      data-toggle="modal"
                      data-target="#prescriptionModal"
                      data-dismiss="modal"
                      class="btn btn-base upload-bazar-button"
                    >
                      <i class="fa fa-upload"></i>
                      <span>আপলোড ফাইল</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="prescriptionModal" class="modal authModal fade" role="dialog">
        <div class="vertical-alignment-helper">
          <div class="modal-dialog vertical-align-center">
            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal">
                  <img src="@/assets/images/close.png" />
                </button>
                <div class="text-center mb40">
                  <span class="logo">
                    <img
                      src="@/assets/images/ghasforing-logo.png"
                      class="img-responsive"
                      style="max-width: 150px; margin: auto"
                      alt="Shah Premium Foods"
                    />
                  </span>
                </div>
                <div>
                  <h3 v-if="globalLanguage == 'EN'">Upload Image File</h3>
                  <h3 v-else>ছবি ফাইল আপলোড করুন</h3>
                  <div class="smslabel" id="PassSuccess"></div>
                  <form v-on:submit.prevent>
                    <div id="cemo"></div>
                    <img
                      class="showloader"
                      v-if="isLoading"
                      src="@/assets/images/tenor.gif"
                      :alt="globalLanguage == 'EN' ? 'loading' : 'লোড হচ্ছে'"
                    />

                    <input
                      required
                      v-model="phone"
                      @change="phoneNumbers"
                      class="form-control checkephone"
                      autocomplete="phone"
                      :placeholder="globalLanguage == 'EN' ? 'Phone Number' : 'ফোন নম্বর'"
                    />

                    <div class="file-upload-wrapper">
                      <input
                        type="file"
                        id="file"
                        ref="file"
                        v-on:change="handleFileUpload()"
                        accept="image/*;capture=camera"
                        class="file-upload"
                      />
                    </div>
                    <button
                      v-on:click="submitFile()"
                      type="submit"
                      class="btn btn-login"
                    >
                      <span v-if="globalLanguage == 'EN'">Upload</span>
                      <span v-else>আপলোড</span>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid sha-popular-brands">
      <div class="sha-section-heading sha-brand-heading">
        <div class="sha-title-inline" v-if="globalLanguage == 'EN'">
          <h4>Popular on Shah Premium Foods</h4>
        </div>
        <div class="sha-title-inline" v-else>
          <h4>শাহ প্রিমিয়াম ফুডসে জনপ্রিয়</h4>
        </div>
      </div>
      <div class="sha-brand-scroller">
        <div class="sha-brand-logo sha-brand-pran">PRAN</div>
        <div class="sha-brand-logo sha-brand-reckitt">reckitt</div>
        <div class="sha-brand-logo sha-brand-nestle">Nestle</div>
        <div class="sha-brand-logo sha-brand-unilever">Unilever</div>
        <div class="sha-brand-logo sha-brand-marico">marico</div>
        <div class="sha-brand-logo sha-brand-godrej">Godrej</div>
        <div class="sha-brand-logo sha-brand-coke">CocaCola</div>
        <div class="sha-brand-logo sha-brand-mgi">MGI</div>
      </div>
    </div>
    <div class="container-fluid sha-app-section">
      <div class="col-md-12">
        <div class="row order-process">
          <div class="sha-app-download">
            <div class="sha-app-copy" v-if="globalLanguage == 'EN'">
              <h2>Download The Shah Premium Foods App Now!</h2>
              <p>
                Get <b>5% off</b> on your first order through the app and make
                your shopping experience even smoother!
              </p>
              <div class="sha-app-store-row">
                <a href="#" class="sha-store-button sha-store-apple">
                  <i class="fa fa-apple"></i>
                  <span>
                    <span v-if="globalLanguage == 'EN'">Download on the</span>
                    <span v-else>ডাউনলোড করুন</span>
                    <b>App Store</b>
                  </span>
                </a>
                <a
                  class="sha-store-button sha-store-google"
                  href="https://play.google.com/store/apps/details?id=com.shahpremiumfood.shahpremiumfood"
                  target="_blank"
                >
                  <img src="@/assets/images/play-store.png" alt="Google Play" />
                </a>
              </div>
            </div>
            <div class="sha-app-copy" v-else>
              <h2>ডাউনলোড শাহপ্রিমিয়াম ফুডস অ্যাপস</h2>
              <p>
                অ্যাপের মাধ্যমে প্রথম অর্ডারে <b>৫% ছাড়</b> পান এবং আরও সহজে
                কেনাকাটা করুন।
              </p>
              <div class="sha-app-store-row">
                <a href="#" class="sha-store-button sha-store-apple">
                  <i class="fa fa-apple"></i>
                  <span>ডাউনলোড করুন <b>App Store</b></span>
                </a>
                <a
                  class="sha-store-button sha-store-google"
                  href="https://play.google.com/store/apps/details?id=com.shahpremiumfood.shahpremiumfood"
                  target="_blank"
                >
                  <img src="@/assets/images/play-store.png" alt="Google Play" />
                </a>
              </div>
            </div>
            <div class="sha-app-phones" aria-hidden="true">
              <div class="sha-phone sha-phone-back">
                <div class="sha-phone-notch"></div>
                <div class="sha-phone-screen sha-phone-brand-screen">
                  <div class="sha-phone-logo">Shah</div>
                </div>
              </div>
              <div class="sha-phone sha-phone-front">
                <div class="sha-phone-notch"></div>
                <div class="sha-phone-screen">
                  <div class="sha-phone-topbar">
                    <span></span>
                    <span></span>
                  </div>
                  <strong v-if="globalLanguage == 'EN'">Popular</strong>
                  <strong v-else>জনপ্রিয়</strong>
                  <div class="sha-phone-product" v-for="item in 8" :key="item">
                    <span class="sha-phone-product-img"></span>
                    <span class="sha-phone-product-info">
                      <i></i>
                      <i></i>
                    </span>
                    <em>+</em>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CartData
      :carts="carts"
      :sum-cart-total="sum_cart_total || 0"
      :file-url="fileUrl"
      :global-language="globalLanguage"
      @remove-cart-item="removeCartItem"
      @cart-increment="cartIncrement"
      @cart-decrement="cartDecrement"
    />
    <div class="mobilemenu">
      <div class="same">
        <a href="/" class="icon-bottom">
          <img src="@/assets/images/icons/home-ash.png" width="31px" />
        </a>
      </div>
      <div class="gocheckout" v-if="carts.length > 0">
        <router-link to="/cart">
          <span v-if="globalLanguage == 'EN'">GO CART</span>
          <span v-else>কার্টে যান</span>
        </router-link>
      </div>
      <div class="gocheckout start" @click="toogleNav()" v-else>
        <span v-if="globalLanguage == 'EN'">START SHOPPING</span>
        <span v-else>কেনাকাটা শুরু করুন</span>
      </div>
      <div class="mybag same carts">
        <span>
          <span class="badge">0</span>
          <img
            class="iconbag"
            src="@/assets/images/icons/bag.png"
            :alt="globalLanguage == 'EN' ? 'Shopping bag' : 'শপিং ব্যাগ'"
            height="31px"
          />
        </span>
      </div>
    </div>
    <div
      id="freeDel"
      class="modal authModal fade in free-delivery"
      role="dialog"
      style="display: block"
      v-if="offer_modal_status == 1"
    >
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div
            class="modal-content bigwidth"
            v-bind:style="{ background: offer_bg + '!important' }"
          >
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal">
                <img src="@/assets/images/close-x.png" />
              </button>
              <div class="text-center">
                <router-link v-if="offer_url" :to="{ path: offer_url }">
                  <img
                    v-bind:src="
                      fileUrl + 'uploads/offer_image/' + offer_modal_img
                    "
                    class="img-responsive"
                  />
                </router-link>
                <img
                  v-else
                  v-bind:src="
                    fileUrl + 'uploads/offer_image/' + offer_modal_img
                  "
                  class="img-responsive"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import apiScript from "../apiScript";
// api.hello();
const $ = require("jquery");
window.$ = $;

$(function() {
  // $(".swiper-container").hover(function() {
  //   (".swiper-container").swiper.autoplay.stop();
  // }, function() {
  //   (".swiper-container").swiper.autoplay.start();
  // });
  $(window).scroll(function() {
    $("nav").toggleClass("scrolled", $(this).scrollTop() > 30);
  });
  $("body").on("click", ".in.free-delivery .close", function(e) {
    $(".free-delivery").hide();
  });
  $("body")
    .on("click", ".modal-open", function(e) {
      $(".modal-background, .modal").show();
      e.preventDefault();
    })
    .on("click", ".modal-close", function(e) {
      $(".modal-background, .modal").hide();
      e.preventDefault();
    });

  if (!$(".modal-background.modal-close").length) {
    $("<div/>")
      .addClass("modal-background modal-close")
      .appendTo("body");
  }
});
import axios from "axios";
import CartData from "./CartData";
import ProductCartControl from "./ProductCartControl";
//import api from '../apiScript';
export default {
  components: { CartData, ProductCartControl },
  data() {
    return {
      offer_modal_img: "",
      offer_modal_status: "",
      offer_bg: "",
      offer_url: "",
      menuStatus: true,
      token: "",
      products: [],
      offer_products: [],
      featuredCategorylist: [],

      getcarts: [],
      modalProductData: [],
      carts: [],
      sliders: [],
      cartsCountProduct: "",
      loadMore: true,
      isLoading: false,
      screenWidth: null,
      storyImage: null,
      isOpen: true,
      showModal: true,
      sum_cart_total: "",
      quantity: 1,
      phone: "",
      user_id: "",
      images: [],
      locations: [],
      modalData: null,
      parseCartData: [],
      changeModalGallery_image: "",
      allCategories: [],
      stories: [],
      related_products: [],
      category_products: [],
      language: "",
      storyUrl: "",
      promoSearch: "",
      affiliate_offer_message_bn: null,
      affiliate_offer_message_en: null,
      cartCollapseTimers: {},
      wishlistIds: [],
      categorySwiperOptions: {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: false,
        speed: 450,
        preventClicks: false,
        observer: true,
        observeParents: true,
        breakpoints: {
          260: {
            spaceBetween: 8
          },
          480: {
            spaceBetween: 10
          },
          640: {
            spaceBetween: 12
          },
          992: {
            spaceBetween: 14
          },
          1400: {
            spaceBetween: 16
          }
        }
      },
      swiperOptions: {
        // slidesPerView: 5,
        loop: false,
        speed: 1000,
        preventClicks: false,
        //autoplay: 4000,
        delay: 2000,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false,
        // },
        breakpoints: {
          // when window width is >= 320px
          260: {
            slidesPerView: 2,
            spaceBetween: 0
          },
          320: {
            slidesPerView: 2,
            spaceBetween: 2
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 2,
            spaceBetween: 2
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 3,
            spaceBetween: 2
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 2
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 2
          },
          1920: {
            slidesPerView: 5,
            spaceBetween: 2
          },
          2500: {
            slidesPerView: 5,
            spaceBetween: 2
          }
        },
        pagination: {
          el: ".swiper-pagination-feature",
          clickable: true
        },
        file: ""
      },
      swiperOptionsPopular: {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: false,
        speed: 1000,
        preventClicks: false,
        delay: 2000,
        breakpoints: {
          260: {
            spaceBetween: 0
          },
          320: {
            spaceBetween: 2
          },
          480: {
            spaceBetween: 2
          },
          640: {
            spaceBetween: 2
          },
          768: {
            spaceBetween: 2
          },
          1024: {
            spaceBetween: 2
          },
          1920: {
            spaceBetween: 2
          },
          2500: {
            spaceBetween: 2
          }
        }
      },
      swiperOption: {
        loop: false,
        speed: 1000,
        preventClicks: false,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true
        },
        breakpoints: {
          260: { slidesPerView: 3, spaceBetween: 7 },
          320: { slidesPerView: 3, spaceBetween: 7 },
          480: { slidesPerView: 3, spaceBetween: 7 },
          640: { slidesPerView: 4, spaceBetween: 7 },
          768: { slidesPerView: 4, spaceBetween: 7 },
          1024: { slidesPerView: 5, spaceBetween: 7 },
          1920: { slidesPerView: 8, spaceBetween: 7 },
          2500: { slidesPerView: 12, spaceBetween: 7 }
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  created: function() {
    //document.title="home page";
    this.getCategories();
    this.featuredCategories();

    this.featuredProducts();
    this.flashSaleProducts();
    //this.deliveryLocations();
    this.language = this.globalLanguage;
    if (localStorage.getItem("userinfo")) {
      this.phone = JSON.parse(localStorage.getItem("userinfo")).phone;
    }
    //localStorage.clear();
    window.addEventListener("beforeunload", function(event) {});
    this.wishlistIds = this.getWishlist().map(x => x.id);
    window.addEventListener("wishlist-updated", this.refreshWishlistIds);
  },
  beforeDestroy() {
    window.removeEventListener("wishlist-updated", this.refreshWishlistIds);
  },
  mounted() {
    // this.getImagesInfo()

    let vm = this;
    vm.screenWidth = window.innerWidth;
    if (localStorage.getItem("token")) {
      let vm = this;
      vm.token = localStorage.getItem("token");
    }
    if (localStorage.getItem("carts")) {
      vm.carts = JSON.parse(localStorage.getItem("carts"));
    } else {
      vm.carts = [];
    }
    vm.cartsCountProduct = JSON.parse(
      localStorage.getItem("cartsCountProduct")
    );
    this.calculateCartTotal();
    this.$nextTick(function() {
      vm.syncCartButtons();
    });
  },
  methods: {
    slideFeaturedCategories(direction) {
      const swiper = this.featuredCategorySwiper;
      if (!swiper) return;
      direction === "next" ? swiper.slideNext() : swiper.slidePrev();
    },
    slidePopularProducts(direction) {
      const swiperEl = document.getElementById("popularProductsSwiper");
      const swiper =
        this.mySwiperPopular || (swiperEl && swiperEl.swiper);
      if (!swiper) return;
      direction === "next" ? swiper.slideNext() : swiper.slidePrev();
    },
    slideOfferProducts(direction) {
      const swiperEl = document.getElementById("offerProductsSwiper");
      const swiper =
        this.mySwiperOffers || (swiperEl && swiperEl.swiper);
      if (!swiper) return;
      direction === "next" ? swiper.slideNext() : swiper.slidePrev();
    },
    slideCategoryProducts(slug, direction) {
      const swiperEl = document.getElementById("categorySwiper-" + slug);
      const swiper = swiperEl && swiperEl.swiper;
      if (!swiper) return;
      direction === "next" ? swiper.slideNext() : swiper.slidePrev();
    },
    focusHeaderSearch() {
      this.$nextTick(() => {
        const headerSearch = document.querySelector(".custom-search");
        if (!headerSearch) return;
        headerSearch.focus();
        if (this.promoSearch) {
          this.syncHeaderSearchValue(this.promoSearch);
        }
      });
    },
    syncPromoSearch() {
      this.syncHeaderSearchValue(this.promoSearch);
      this.focusHeaderSearch();
    },
    syncHeaderSearchValue(value) {
      const headerSearch = document.querySelector(".custom-search");
      if (!headerSearch) return;
      headerSearch.value = value || "";
      headerSearch.dispatchEvent(new Event("input", { bubbles: true }));
    },
    hasCartQuantity(productId) {
      const cart = this.carts.find(item => item.product_id == productId);
      return Boolean(cart && Number(cart.cart_quantity) > 0);
    },
    inWishlist(productId) {
      return this.wishlistIds.indexOf(productId) !== -1;
    },
    refreshWishlistIds() {
      this.wishlistIds = this.getWishlist().map(x => x.id);
    },
    toggleWishlistClick(product) {
      // toggleWishlist() dispatches "wishlist-updated" synchronously, which
      // refreshWishlistIds() picks up immediately — no need to also patch
      // wishlistIds here (doing so double-toggled it and showed the wrong icon).
      this.toggleWishlist(product);
    },

    StoreShow(storyImage, url) {
      this.storyImage = storyImage;
      this.storyUrl = url;
    },
    homeQuickView(product_id) {
      let vm = this;
      const result = this.carts.find(function(obj) {
        return obj.product_id == product_id;
      });
      if (result === undefined) {
        vm.quantity = 1;
      } else {
        let oldQuantity = result.cart_quantity;
        vm.quantity = oldQuantity;
      }
      axios
        .get(this.globalUrl + "products/" + product_id)
        .then(function(response) {
          console.log(response.data.product);
          vm.modalData = response.data.product;
          vm.related_products = response.data.related_products;
          vm.changeModalGallery_image = response.data.product.featured_image;
        })
        .catch(response => {
          //console.log(response);
          vm.$toasted.show(
            vm.globalLanguage == "EN"
              ? "Something wrong  Try again."
              : "কিছু ভুল হয়েছে, আবার চেষ্টা করুন।",
            {
            type: "error",
            icon: "fa-exclamation-triangle"
            }
          );
        });
    },
    stopSwip(event) {
      event.target.swiper.autoplay.stop();
    },
    startSwip(event) {
      event.target.swiper.autoplay.start();
    },
    removeCartItem: function(product_id) {
      //alert(product_id);
      this.carts = this.carts.filter(e => e.product_id !== product_id);
      $("#product_" + product_id).removeClass("cartAdded open");
      localStorage.setItem("carts", JSON.stringify(this.carts));
      this.calculateCartTotal();
    },
    openCartControl: function(product_id) {
      // "cartAdded" stays on as long as the item is in the cart (it also
      // drives the quantity badge shown in place of the plus icon); "open"
      // is the transient expanded +/- state on touch devices.
      $("#product_" + product_id).addClass("cartAdded open");
    },
    scheduleCartAutoClose: function(product_id) {
      // On touch devices there's no hover to collapse the +/- control back
      // to the plain add button, so force it closed after 15s of inactivity.
      if (!window.matchMedia("(hover: none)").matches) return;
      if (this.cartCollapseTimers[product_id]) {
        clearTimeout(this.cartCollapseTimers[product_id]);
      }
      this.cartCollapseTimers[product_id] = setTimeout(function() {
        $("#product_" + product_id).removeClass("open");
      }, 10000);
    },
    closeOtherCartControls: function(product_id) {
      // On touch devices only one product's +/- control should stay expanded
      // at a time, so opening one collapses any other one left open.
      if (!window.matchMedia("(hover: none)").matches) return;
      $(".home-cart-control.open, .related-cart-control.open")
        .not("#product_" + product_id)
        .removeClass("open");
    },
    addOrIncrementCart(index, product_id) {
      if (this.products[index].stock_quantity < 1) {
        this.$toasted.show(
          this.globalLanguage == "EN"
            ? "Out of Stock. Not Added In your Bag."
            : "স্টকে নেই। আপনার ব্যাগে যোগ করা হয়নি।",
          {
          type: "error",
          icon: "fa-exclamation-triangle",
          position: "bottom-left"
          }
        );
        return;
      }
      let exists =
        this.carts.findIndex(obj => obj.product_id == product_id) !== -1;
      if (exists) {
        this.cartIncrement(product_id);
      } else {
        this.createCarts(index, product_id);
      }
    },
    createCarts: function(index, product_id) {
      let vm = this;
      let thisProductID = product_id;
      //$("#"+index +" .amountQuantity").text(1);
      //alert(thisProductID);
      //check  array  index  product  info
      //console.log(this.products[index]);
      this.closeOtherCartControls(product_id);
      $("#product_" + product_id + " .amountQuantity").text(1);
      let check_if_cart_item_exist = this.carts.findIndex(
        x => x.product_id === this.products[index].id
      );
      if (check_if_cart_item_exist >= 0) {
        this.openCartControl(product_id);
        let objIndex = this.carts.findIndex(
          x => x.product_id === this.products[index].id
        );
        let oldQuantity = this.carts[objIndex].cart_quantity;
        $("#product_" + product_id + " .amountQuantity").text(oldQuantity);
      } else {
        this.openCartControl(thisProductID);

        //console.log(this.products[index].id);
        let result = JSON.parse(localStorage.getItem("carts"));
        if (result == null) result = [];
        let price = this.products[index].price - this.products[index].discount;
        //console.log(price);
        result.unshift({
          product_id: this.products[index].id,
          product_name: this.products[index].name,
          product_name_bn: this.products[index].name_bn,
          product_image: this.products[index].featured_image,
          price: price,
          image: this.products[index].featured_image,
          quantity: this.products[index].unit_quantity,
          unit: this.products[index].unit,
          cart_quantity: 1,
          stock_quantity: this.products[index].stock_quantity,
          subtotal: price * 1
        });
        // save the new result array
        localStorage.setItem("carts", JSON.stringify(result));
        vm.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
        vm.$toasted.show(
          vm.globalLanguage == "EN"
            ? "New Product Added In your Bag."
            : "নতুন পণ্য আপনার ব্যাগে যোগ হয়েছে।",
          {
          type: "success",
          icon: "fa-check-circle",
          position: "bottom-left"
          }
        );
        $(".carts").addClass("animated zoomIn");
        $(".cart_amount").addClass("shadow-pulse");
        setTimeout(function() {
          $(".carts").removeClass("animated zoomIn");
          $(".cart_amount").removeClass("shadow-pulse");
        }, 5000);
      }
      this.scheduleCartAutoClose(product_id);
    },
    syncCartButtons: function() {
      this.carts.forEach(function(cart) {
        $("#product_" + cart.product_id).addClass("cartAdded");
        $("#product_" + cart.product_id + " .amountQuantity").text(
          cart.cart_quantity
        );
      });
    },
    featuredProducts: function() {
      let vm = this;
      axios
        .get(this.globalUrl + "featured-products")
        .then(function(response) {
          //console.log(response.data);
          vm.products = response.data.featured_products;
          vm.category_products = response.data.products;
          vm.sliders = response.data.sliders;
          vm.stories = response.data.stories;
          vm.$nextTick(function() {
            vm.syncCartButtons();
          });
        })
        .catch(response => {
          //console.log(response);
          vm.$toasted.show(
            vm.globalLanguage == "EN"
              ? "Something wrong  Try again."
              : "কিছু ভুল হয়েছে, আবার চেষ্টা করুন।",
            {
            type: "error",
            icon: "fa-exclamation-triangle"
            }
          );
        });
    },
    flashSaleProducts: function() {
      let vm = this;
      axios
        .get(this.globalUrl + "category/flash-sales")
        .then(function(response) {
          const payload = response.data || {};
          let products = [];
          if (Array.isArray(payload)) {
            products = payload;
          } else if (Array.isArray(payload.data)) {
            products = payload.data;
          } else if (payload.data && Array.isArray(payload.data.data)) {
            products = payload.data.data;
          } else if (Array.isArray(payload.products)) {
            products = payload.products;
          } else if (payload.data && Array.isArray(payload.data.products)) {
            products = payload.data.products;
          } else if (payload.category && Array.isArray(payload.category.data)) {
            products = payload.category.data;
          }
          vm.offer_products = products;
          vm.$nextTick(function() {
            vm.syncCartButtons();
          });
        })
        .catch(() => {
          vm.offer_products = [];
        });
    },
    deliveryLocations: function() {
      let vm = this;
      axios
        .get(this.globalUrl + "all-delivery-locations")
        .then(function(response) {
          //console.log(response.data);
          vm.offer_modal_img = response.data.offer.offer_image;
          vm.offer_modal_status = response.data.offer.status;
          vm.offer_bg = response.data.offer.color;
          vm.offer_url = response.data.offer.url;
          if (response.data.affiliate_offer.message_bn) {
            vm.affiliate_offer_message_bn =
              response.data.affiliate_offer.message_bn;
          }
          if (response.data.affiliate_offer.message_en) {
            vm.affiliate_offer_message_en =
              response.data.affiliate_offer.message_en;
          }
        })
        .catch(response => {
          //console.log(response);
          vm.$toasted.show(
            vm.globalLanguage == "EN"
              ? "Something wrong  Try again."
              : "কিছু ভুল হয়েছে, আবার চেষ্টা করুন।",
            {
            type: "error",
            icon: "fa-exclamation-triangle"
            }
          );
        });
    },
    submitFile() {
      let vm = this;
      if (this.file != "" && this.phone != "") {
        this.isLoading = true;
        let formData = new FormData();

        if (localStorage.getItem("userinfo")) {
          this.user_id = JSON.parse(localStorage.getItem("userinfo")).id;
        }

        formData.append("file", this.file);
        formData.append("phone", this.phone);
        formData.append("user_id", this.user_id);

        axios
          .post(this.globalUrl + "upload-prescription", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(function(response) {
            vm.isLoading = false;
            console.log(response);
            vm.$toasted.show(
              vm.globalLanguage == "EN"
                ? "File  Upload success, we will call you soon."
                : "ফাইল আপলোড সফল হয়েছে, আমরা শীঘ্রই কল করব।",
              {
              type: "success",
              icon: "fa-check-circle",
              position: "top-right"
              }
            );
            vm.file = "";
            vm.phone = "";
          })
          .catch(function(response) {
            console.log(response);
            vm.isLoading = false;
            vm.$toasted.show(
              vm.globalLanguage == "EN"
                ? "Something wrong Refresh & try again."
                : "কিছু ভুল হয়েছে, রিফ্রেশ করে আবার চেষ্টা করুন।",
              {
              type: "error",
              icon: "fa-exclamation-triangle",
              position: "top-right"
              }
            );
          });
      } else {
        vm.isLoading = false;
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.phoneNumbers();
    },
    phoneNumbers: function() {
      let phone = this.phone;
      console.log(phone);
      // let check = phone.match(/^(?:\+?88)?01[15-9]\d{8}$/);
      let check = phone.match(/^(01[3456789])(\d{8})$/);
      //console.log(check);
      if (check === null) {
        $(".checkephone").removeClass("success");
        $(".checkephone").addClass("error");
        $("#prescriptionModal .btn-login").addClass("disabled");
      } else {
        $(".checkephone").removeClass("error");
        $(".checkephone").addClass("success");
        $("#prescriptionModal .btn-login").removeClass("disabled");
      }
    },
    toogleNav: function() {
      $(".small-device #sidebar-area").toggleClass("show");
      $("#content-area").toggleClass("fullwidth");
      $("#sidebar-area").toggleClass("hidden-sidebar");
      if (this.menuStatus == true) {
        this.menuStatus = false;
      } else if (this.menuStatus == false) {
        this.menuStatus = true;
      }
    },
    getCategories: function() {
      let vm = this;
      axios
        .get(this.globalUrl + "all-category-list")
        .then(function(response) {
          //console.log(response.data.data[2]);
          vm.allCategories = response.data;
        })
        .catch(response => {
          vm.$toasted.show(
            vm.globalLanguage == "EN"
              ? "Something wrong  Refresh Again."
              : "কিছু ভুল হয়েছে, আবার রিফ্রেশ করুন।",
            {
            type: "error",
            icon: "fa-exclamation-triangle"
            }
          );
        });
    },
    featuredCategories: function() {
      let vm = this;
      axios
        .get(this.globalUrl + "v2/home-categories")
        .then(function(response) {
        console.log(response);
           vm.featuredCategorylist = response.data.data;
        })
        .catch(response => {
          vm.$toasted.show(
            vm.globalLanguage == "EN"
              ? "Something wrong  Refresh Again."
              : "কিছু ভুল হয়েছে, আবার রিফ্রেশ করুন।",
            {
            type: "error",
            icon: "fa-exclamation-triangle"
            }
          );
        });
    },
    increment(product_id) {
      //this.quantity++
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);

      if (objIndex != -1) {
        let oldQuantity = this.carts[objIndex].cart_quantity;
        let stock_quantity = this.carts[objIndex].stock_quantity;
        if (this.quantity < stock_quantity) {
          let newQuantity = oldQuantity + 1;
          let price = this.carts[objIndex].price;
          this.carts[objIndex].cart_quantity = newQuantity;
          this.carts[objIndex].subtotal = price * newQuantity;
          localStorage.setItem("carts", JSON.stringify(this.carts));
          this.carts = JSON.parse(localStorage.getItem("carts"));
          $("#product_" + product_id + " .amountQuantity").text(newQuantity);
          this.calculateCartTotal();
          this.quantity = newQuantity;
        } else {
          this.$toasted.show(
            "<span>" +
              this.carts[objIndex].stock_quantity +
              "</span>" +
              (this.globalLanguage == "EN"
                ? "Quantity is available, Please call for more Quantity."
                : "টি পণ্য আছে, আরও পরিমাণের জন্য কল করুন।"),
            {}
          );
        }
      } else {
        let objIndex = this.products.findIndex(obj => obj.id == product_id);
        let stock_quantity = Math.trunc(this.products[objIndex].stock_quantity);
        if (this.quantity < stock_quantity) {
          this.quantity++;
        } else {
          this.quantity;
          this.$toasted.show(
            "<span>" +
              stock_quantity +
              "</span>" +
              (this.globalLanguage == "EN"
                ? "Quantity is available, Please call for more Quantity."
                : "টি পণ্য আছে, আরও পরিমাণের জন্য কল করুন।"),
            {}
          );
        }
      }
    },
    decrement(product_id) {
      if (this.quantity === 1) {
      } else {
        this.quantity--;
        let objIndex = this.carts.findIndex(
          obj => obj.product_id == product_id
        );
        if (objIndex != -1) {
          let oldQuantity = this.carts[objIndex].cart_quantity;
          if (oldQuantity > 1) {
            let newQuantity = oldQuantity - 1;
            let price = this.carts[objIndex].price;
            this.carts[objIndex].cart_quantity = newQuantity;
            this.carts[objIndex].subtotal = price * newQuantity;
            localStorage.setItem("carts", JSON.stringify(this.carts));
            this.carts = JSON.parse(localStorage.getItem("carts"));
            this.calculateCartTotal();
            $("#product_" + product_id + " .amountQuantity").text(newQuantity);
          }
        }
      }
    },
    cartIncrement(product_id) {
      let vm = this;
      //alert(product_id);
      this.closeOtherCartControls(product_id);
      this.openCartControl(product_id);
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      let oldQuantity = this.carts[objIndex].cart_quantity;
      let stock_quantity = this.carts[objIndex].stock_quantity;
      if (oldQuantity < stock_quantity) {
        let newQuantity = oldQuantity + 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.carts = JSON.parse(localStorage.getItem("carts"));
        $("#product_" + product_id + " .amountQuantity").text(newQuantity);
        this.calculateCartTotal();
        $("#product_" + product_id).addClass("animated");
        setTimeout(function() {
          $("#product_" + product_id).removeClass("animated");
        }, 500);
        this.scheduleCartAutoClose(product_id);
      } else {
        vm.$toasted.show(
          "<span>" +
            stock_quantity +
            "</span>" +
            (vm.globalLanguage == "EN"
              ? "Quantity is available, Please call for more Quantity."
              : "টি পণ্য আছে, আরও পরিমাণের জন্য কল করুন।"),
          {}
        );
      }
    },
    createCartsModal: function() {
      let vm = this;
      let this_product_quantity = vm.quantity;
      let singleProduct = vm.modalData;
      // alert(vm.modalData.id);
      // alert(singleProduct.id);
      let check_if_cart_item_exist = this.carts.findIndex(
        x => x.product_id === singleProduct.id
      );
      if (check_if_cart_item_exist >= 0) {
        vm.$toasted.show(
          vm.globalLanguage == "EN"
            ? "Already Added In your Bag."
            : "ইতিমধ্যে আপনার ব্যাগে যোগ হয়েছে।",
          {
          type: "error",
          icon: "fa-exclamation-triangle",
          position: "bottom-left"
          }
        );
      } else {
        let result = JSON.parse(localStorage.getItem("carts"));
        if (result == null) result = [];
        let price = singleProduct.price - singleProduct.discount;
        if (this_product_quantity <= singleProduct.stock_quantity) {
          this_product_quantity = this_product_quantity;
        } else {
          this_product_quantity = Math.trunc(singleProduct.stock_quantity);
        }
        result.unshift({
          product_id: singleProduct.id,
          product_name: singleProduct.name,
          product_name_bn: singleProduct.name_bn,
          product_image: singleProduct.featured_image,
          price: price,
          image: singleProduct.featured_image,
          cart_quantity: this_product_quantity,
          quantity: singleProduct.unit_quantity,
          unit: singleProduct.unit,
          stock_quantity: singleProduct.stock_quantity,
          subtotal: price * this_product_quantity
        });
        // save the new result array
        localStorage.setItem("carts", JSON.stringify(result));
        vm.carts = JSON.parse(localStorage.getItem("carts"));
        this.openCartControl(singleProduct.id);
        $("#product_" + singleProduct.id + " .amountQuantity").text(
          this_product_quantity
        );
        this.calculateCartTotal();
        vm.$toasted.show(
          vm.globalLanguage == "EN"
            ? "New Product Added In your Bag."
            : "নতুন পণ্য আপনার ব্যাগে যোগ হয়েছে।",
          {
          type: "success",
          icon: "fa-check-circle",
          position: "bottom-left"
          }
        );
      }
    },
    closeRelatedCartControl(product_id) {
      // A real mouse still fires mouseleave even on devices that report
      // (hover: none), so this clears the tap-to-open "open" state as soon
      // as the cursor actually leaves, instead of waiting for the touch-only
      // auto-close timeout.
      if (this.cartCollapseTimers[product_id]) {
        clearTimeout(this.cartCollapseTimers[product_id]);
      }
      $("#product_" + product_id).removeClass("open");
    },
    getCartQuantity(productId) {
      const cart = this.carts.find(item => item.product_id == productId);
      return cart ? cart.cart_quantity : 0;
    },
    addRelatedToCart(product) {
      let vm = this;
      if (product.stock_quantity < 1) {
        vm.$toasted.show(
          vm.globalLanguage == "EN"
            ? "Out of Stock. Not Added In your Bag."
            : "স্টকে নেই। আপনার ব্যাগে যোগ করা হয়নি।",
          {
          type: "error",
          icon: "fa-exclamation-triangle",
          position: "bottom-left"
          }
        );
        return;
      }
      this.closeOtherCartControls(product.id);
      let exists =
        this.carts.findIndex(obj => obj.product_id == product.id) !== -1;
      if (exists) {
        this.cartIncrement(product.id);
        return;
      }
      this.openCartControl(product.id);
      let result = JSON.parse(localStorage.getItem("carts"));
      if (result == null) result = [];
      let price = product.price - product.discount;
      result.unshift({
        product_id: product.id,
        product_name: product.name,
        product_name_bn: product.name_bn,
        product_image: product.featured_image,
        price: price,
        image: product.featured_image,
        quantity: product.unit_quantity,
        unit: product.unit,
        cart_quantity: 1,
        stock_quantity: product.stock_quantity,
        subtotal: price * 1
      });
      localStorage.setItem("carts", JSON.stringify(result));
      vm.carts = JSON.parse(localStorage.getItem("carts"));
      this.calculateCartTotal();
      vm.$toasted.show(
        vm.globalLanguage == "EN"
          ? "New Product Added In your Bag."
          : "নতুন পণ্য আপনার ব্যাগে যোগ হয়েছে।",
        {
        type: "success",
        icon: "fa-check-circle",
        position: "bottom-left"
        }
      );
      this.scheduleCartAutoClose(product.id);
    },
    cartDecrement(product_id) {
      this.closeOtherCartControls(product_id);
      this.openCartControl(product_id);
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      let oldQuantity = this.carts[objIndex].cart_quantity;
      if (oldQuantity > 1) {
        let newQuantity = oldQuantity - 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
        $("#product_" + product_id + " .amountQuantity").text(newQuantity);
        $("#product_" + product_id).addClass("animated");
        setTimeout(function() {
          $("#" + product_id).removeClass("animated");
        }, 500);
        this.scheduleCartAutoClose(product_id);
      } else if (oldQuantity == 1) {
        this.carts = this.carts.filter(e => e.product_id !== product_id);
        $("#product_" + product_id).removeClass("cartAdded open");
        if (this.cartCollapseTimers[product_id]) {
          clearTimeout(this.cartCollapseTimers[product_id]);
        }
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.calculateCartTotal();
      }
    },
    calculateCartTotal() {
      let vm = this;
      for (
        var i = 0, sum = 0;
        i < vm.carts.length;
        sum += vm.carts[i++].subtotal
      );
      vm.sum_cart_total = sum;
      for (
        var i = 0, totalSum = 0;
        i < vm.carts.length;
        totalSum += vm.carts[i++].cart_quantity
      );
      vm.cartsCountProduct = totalSum;
      localStorage.setItem("cartsCountProduct", totalSum);
      $(".carts .badge").text(vm.carts.length);
    },
    galleryImg: function(image_url) {
      let vm = this;
      vm.changeModalGallery_image = image_url;
    }
  }
};
</script>

<style scoped>
.upload-bazar-row {
  display: flex;
  align-items: center;
}

.upload-bazar-row > [class*="col-"] {
  float: none;
}

@media only screen and (max-width: 500px) {
  .upload-bazar-row {
    display: block;
  }
}

.home-grocery-promo {
  position: relative;
  display: grid;
  grid-template-columns: minmax(320px, 1fr) minmax(420px, 1.05fr);
  align-items: center;
  max-height: 415px;
  padding: 44px 34px 38px;
  overflow: hidden;
  border-top: 1px solid rgba(0, 147, 69, 0.12);
  border-bottom: 1px solid rgba(0, 147, 69, 0.16);
  background:
    linear-gradient(110deg, rgba(255, 255, 255, 0.95) 0%, rgba(232, 248, 239, 0.94) 48%, rgba(0, 147, 69, 0.16) 100%),
    #f3fbf6;
}

.home-grocery-promo::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 6px;
  height: 100%;
  background: #009345;
}

.home-grocery-copy {
  position: relative;
  z-index: 2;
  max-width: 560px;
}

.home-grocery-copy h1 {
  margin: 0 0 16px;
  color: #060606;
  font-size: 40px;
  font-weight: 900;
  line-height: 1.08;
  letter-spacing: 0;
  text-transform: uppercase;
}

.home-grocery-cuisines {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 10px;
  margin: 0 0 28px;
  color: #244231;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.2;
}

.home-grocery-cuisines span {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.home-grocery-cuisines span:not(:last-child)::after {
  content: "•";
  margin-left: 10px;
  color: #f89406;
  font-weight: 900;
}

.home-grocery-cuisines.bn {
  font-size: 17px;
  font-weight: 700;
}

.home-grocery-search {
  position: relative;
  display: flex;
  width: min(100%, 540px);
  height: 56px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.16);
  border-radius: 7px;
  background: #fff;
  box-shadow: 0 12px 24px rgba(0, 82, 39, 0.1);
}

.home-grocery-search:focus-within {
  border-color: #009345;
  box-shadow: 0 0 0 3px rgba(0, 147, 69, 0.12), 0 12px 24px rgba(0, 82, 39, 0.1);
}

.home-grocery-search input {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  padding: 0 18px;
  border: 0;
  color: #202020;
  font-size: 18px;
  font-weight: 500;
  outline: 0;
}

.home-grocery-search input::placeholder {
  color: #777777;
}

.home-grocery-search button {
  flex: 0 0 58px;
  width: 58px;
  border: 0;
  background: #fff;
  color: #009345;
  font-size: 25px;
  line-height: 1;
  outline: 0;
}

.home-grocery-media {
  position: relative;
  z-index: 1;
  height: 310px;
}

.home-grocery-photo {
  position: absolute;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 9px 20px rgba(0, 70, 34, 0.18);
}

.home-grocery-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.home-grocery-photo.photo-main {
  left: 2%;
  top: 48px;
  width: 32%;
  height: 220px;
}

.home-grocery-photo.photo-top {
  left: 40%;
  top: 0;
  width: 21%;
  height: 126px;
}

.home-grocery-photo.photo-mid {
  left: 40%;
  top: 138px;
  width: 21%;
  height: 188px;
}

.home-grocery-photo.photo-tall {
  left: 63%;
  top: 18px;
  width: 24%;
  height: 214px;
}

.home-grocery-photo.photo-bottom {
  left: 63%;
  top: 244px;
  width: 24%;
  height: 104px;
}

.home-grocery-photo.photo-edge {
  left: 89%;
  top: 88px;
  width: 18%;
  height: 190px;
}

@media only screen and (max-width: 991px) {
  .home-grocery-promo {
    grid-template-columns: 1fr;
    gap: 24px;
    padding: 36px 22px 28px;
  }

  .home-grocery-copy {
    max-width: 100%;
  }

  .home-grocery-copy h1 {
    max-width: 620px;
    margin-bottom: 14px;
    font-size: 36px;
  }

  .home-grocery-cuisines {
    margin-bottom: 22px;
    font-size: 15px;
  }

  .home-grocery-search {
    width: 100%;
    max-width: 620px;
  }

  .home-grocery-media {
    height: 230px;
  }

  .home-grocery-photo.photo-main {
    left: 0;
    top: 18px;
    width: 34%;
    height: 178px;
  }

  .home-grocery-photo.photo-top {
    left: 37%;
    top: 0;
    width: 28%;
    height: 104px;
  }

  .home-grocery-photo.photo-mid {
    left: 37%;
    top: 116px;
    width: 28%;
    height: 112px;
  }

  .home-grocery-photo.photo-tall {
    left: 68%;
    top: 18px;
    width: 28%;
    height: 178px;
  }

  .home-grocery-photo.photo-bottom,
  .home-grocery-photo.photo-edge {
    display: none;
  }
}

@media only screen and (max-width: 575px) {
  .home-grocery-promo {
    min-height: 0;
    margin: 6px 0 18px;
    padding: 28px 16px 22px;
  }

  .home-grocery-copy h1 {
    font-size: 28px;
    line-height: 1.18;
  }

  .home-grocery-cuisines {
    gap: 7px 8px;
    margin-bottom: 20px;
    font-size: 13px;
  }

  .home-grocery-cuisines span:not(:last-child)::after {
    margin-left: 8px;
  }

  .home-grocery-cuisines.bn {
    font-size: 14px;
  }

  .home-grocery-search {
    height: 52px;
  }

  .home-grocery-search input {
    padding: 0 14px;
    font-size: 15px;
  }

  .home-grocery-search button {
    flex-basis: 48px;
    width: 48px;
    font-size: 22px;
  }

  .home-grocery-media {
    height: 172px;
  }

  .home-grocery-photo.photo-main {
    top: 16px;
    width: 41%;
    height: 130px;
  }

  .home-grocery-photo.photo-top {
    left: 45%;
    width: 25%;
    height: 78px;
  }

  .home-grocery-photo.photo-mid {
    left: 45%;
    top: 88px;
    width: 25%;
    height: 84px;
  }

  .home-grocery-photo.photo-tall {
    left: 73%;
    top: 16px;
    width: 27%;
    height: 130px;
  }
}

.related-products-section {
  padding: 0 15px 10px;
}

.related-products-section hr {
  margin-top: 0;
}

.related-title {
  margin: 0 0 15px;
  font-size: 16px;
  font-weight: 600;
  color: #000;
}

.related-products-scroll {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 8px;
  scrollbar-width: thin;
}

.related-products-scroll::-webkit-scrollbar {
  height: 6px;
}

.related-products-scroll::-webkit-scrollbar-thumb {
  background: #e0e0e0;
  border-radius: 6px;
}

.related-product-card {
  flex: 0 0 140px;
  width: 140px;
  border: 1px solid #eee;
  border-radius: 8px;
  cursor: pointer;
  background: #fff;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.related-product-card:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.related-product-img {
  position: relative;
  height: 110px;
  padding: 8px;
}

.related-product-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.related-product-info {
  padding: 0 10px 10px;
}

.related-product-price {
  color: #f89406;
  font-weight: 600;
  font-size: 13px;
}

.related-product-name {
  font-size: 12px;
  color: #333;
  margin-top: 2px;
  line-height: 1.3;
}

@media only screen and (min-width: 1900px) {
  .container-fluid,
  .banner-area.story-banner,
  .banner-area.products-banner {
    max-width: 1200px;
    margin-left: 0;
    margin-right: auto;
    float: none;
  }
}

/* Make all sections in this component full width and responsive */
.index-fullwidth .container-fluid {
  max-width: 100% !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
}

/* Category area: use CSS grid so number of columns adapts to available width */
.index-fullwidth .center-column-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 18px;
  align-items: start;
}

/* Ensure bootstrap column floats don't break the grid */
.index-fullwidth .center-column-wrapper > .col {
  float: none !important;
  width: auto !important;
}

/* Make bindarea and cat elements stretch to fill grid cells */
.index-fullwidth .bindarea,
.index-fullwidth .bindarea .cat {
  height: 100%;
}

/* Optional: responsive product card grid for non-swiper lists (if present) */
.index-fullwidth .responsive-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 18px;
}

/* Override products-banner margins and make it full width + left aligned */
.index-fullwidth .banner-area.products-banner,
.index-fullwidth .banner-area.story-banner {
  max-width: 100% !important;
  width: 100% !important;
}

.index-fullwidth .banner-area.products-banner .sec-title {
  padding-left: 0 !important;
  text-align: left !important;
}

/* Left-align category blocks */
.index-fullwidth .categories .cat {
  text-align: left !important;
  padding-left: 0 !important;
}

.index-fullwidth .categories .cname {
  text-align: left !important;
}
</style>
